import React, { Component } from 'react'
import {
  Header,
  Footer,
  Card,
  XXLText,
  XXMText,
  ProgressBar,
  FlexWrapper,
  PageWrapper,
  StyledImage
} from '../components'

class Meals extends Component {
  state = {}
  render() {
    return (
      <React.Fragment>
        <Header title="Welcome emily" showProfile onClickProfile={() => this.props.history.push('/user-profile')} />
        <PageWrapper viewPadding="20px 16px" height="132px" viewMargin="60px 0 0 0">
          <Card boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)" borderRadius="5px" bgColor="#fff">
            <FlexWrapper direction="row">
              <FlexWrapper>
                <XXLText color="#124b5f">Your GreenScore</XXLText>
                <XXMText>Your scores are the average of all your purchases.</XXMText>
              </FlexWrapper>
              <ProgressBar percentage={87} initialAnimation={true} strokeWidth={14} fill="#4dff79" />
            </FlexWrapper>
          </Card>
          <FlexWrapper direction="row" alignItems="center" justifyContent="space-between" viewPadding="30px 0 10px">
            <XXLText color="#124b5f" font="Chivo">
              Favorite Products
            </XXLText>
          </FlexWrapper>
          <Card
            boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
            borderRadius="5px"
            bgColor="#fff"
            padding="16px 16px 20px 20px">
            <StyledImage src={require('../static/images/food.png')} alt="chicken" height="83px" />
            <ProgressBar percentage={87} initialAnimation={true} strokeWidth={14} fill="#ffd24d" />
          </Card>
        </PageWrapper>
        <Footer />
      </React.Fragment>
    )
  }
}

export default Meals



// WEBPACK FOOTER //
// ./src/pages/Meals.js